import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ConditionalBgTagComponent } from '../../../ui/conditional-bg-tag/conditional-bg-tag.component';
import { GridColumnBase } from 'src/app/shared/classes/list/grid-column-base';
import {
  getDisplayStyleByFieldId,
  getDisplayStyleForNumber
} from 'src/app/shared/functions/helpers/display-style-helpers';
import { DecimalPipe } from '../../../../pipes/decimal/decimal.pipe';
import { TableFieldDataType } from 'src/models/ts/table-field-data-type.model';
import _ from 'lodash';

@Component({
  selector: 'bizz-grid-group-header-numeric',
  standalone: true,
  templateUrl: './grid-group-header-numeric.component.html',
  styleUrls: ['./grid-group-header-numeric.component.scss'],
  imports: [ConditionalBgTagComponent, DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GridGroupHeaderNumericComponent {

  public column = input.required<GridColumnBase>();

  public value = input.required<string>();

  public maxDecimals = input<number | undefined>(undefined);

  public columnHasDisplayStyle = computed(() => this.column().DisplayStyleValues &&
    this.column().DisplayStyleValues.length > 0);

  public valueText = computed(() => {
    if (this.column().FieldType == TableFieldDataType.Combobox ||
      this.column().FieldType == TableFieldDataType.RadioGroup) {
      if (this.column().values?.length > 0 && !isNaN(Number(this.value())))
        return this.column().values.find(x => x.value == Number(this.value()))?.text ?? '';
    }
    return this.value();
  });

  public displayValue = computed(() => {
    if (this.value()) {
      if (this.column().FieldType == TableFieldDataType.Numeric) {
        const numericValue = Number(this.value());
        return getDisplayStyleForNumber(this.column().DisplayStyleValues,
          numericValue);
      } else if (this.column().FieldType == TableFieldDataType.Combobox ||
        this.column().FieldType == TableFieldDataType.RadioGroup) {
        return getDisplayStyleByFieldId(this.column().DisplayStyleValues,
          this.fieldValueId());
      }
    }
    return null;
  });

  public backgroundColor = computed(() => this.displayValue()?.BackgroundColor ?? '');

  public foregroundColor = computed(() => this.displayValue()?.ForegroundColor ?? '');

  public fieldValueId = computed(() => {
    if (this.gridData() && this.gridData().length > 0 && this.column() && this.value()) {
      //We need to use lodash get to access nested properties (e.g. row[0].Fields[6].prop).
      const row = this.gridData().find(x => _.get(x, this.column().field) == this.value());
      if (row)
        return _.get(row, this.column().field + '_ID');
    }
    return -1;
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public gridData = input<any[]>([]);

  public TableFieldDataType = TableFieldDataType;

}
